export class LoginQueryModel {
    public userId: string;
    public password: string;
}